// This optional code is used to register a service worker.
// register() is not called by default.

// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on subsequent visits to a page, after all the
// existing tabs open on the page have been closed, since previously cached
// resources are updated in the background.

// To learn more about the benefits of this model and instructions on how to
// opt-in, read https://cra.link/PWA

const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

const isLocalhost = Boolean(
    window.location.hostname === 'localhost' ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === '[::1]' ||
    // 127.0.0.0/8 are considered localhost for IPv4.
    window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
);

export default function register(config) {
    if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
        // The URL constructor is available in all browsers that support SW.
        const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
        if (publicUrl.origin !== window.location.origin) {
            // Our service worker won't work if PUBLIC_URL is on a different origin
            // from what our page is served on. This might happen if a CDN is used to
            // serve assets; see https://github.com/facebook/create-react-app/issues/2374
            return;
        }

        window.addEventListener('load', () => {
            

            if (isLocalhost) {
                // This is running on localhost. Let's check if a service worker still exists or not.
                checkValidServiceWorker(swUrl, config);

                // Add some additional logging to localhost, pointing developers to the
                // service worker/PWA documentation.
                navigator.serviceWorker.ready.then(() => {
                    console.log(
                        'This web app is being served cache-first by a service ' +
                        'worker. To learn more, visit https://cra.link/PWA'
                    );
                });
            } else {
                // Is not localhost. Just register service worker
                registerValidSW(swUrl, config);
            }
        });
    }
}

function registerValidSW(swUrl, config) {
    let refreshing = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (refreshing) return;
        refreshing = true;
        // Set a flag so the reloaded page knows to show the "updated" banner
        try { sessionStorage.setItem('sw-updated', '1'); } catch (e) {}
        window.location.reload();
    });

    navigator.serviceWorker
        .register(swUrl)
        .then((registration) => {
            // Case A: A SW is already waiting (from a previous session).
            // Activate it immediately.
            if (registration.waiting) {
                activateUpdate(registration);
            }

            registration.onupdatefound = () => {
                const installingWorker = registration.installing;
                if (installingWorker == null) {
                    return;
                }
                installingWorker.onstatechange = () => {
                    if (installingWorker.state === 'installed') {
                        if (navigator.serviceWorker.controller) {
                            // Case B: New content precached during this visit.
                            console.log('New content is available.');
                            activateUpdate(registration);
                        } else {
                            // First install — content cached for offline use.
                            console.log('Content is cached for offline use.');
                            if (config && config.onSuccess) {
                                config.onSuccess(registration);
                            }
                        }
                    }
                };
            };
        })
        .catch((error) => {
            console.error('Error during service worker registration:', error);
        });

    function activateUpdate(registration) {
        if (registration.waiting) {
            registration.waiting.postMessage({ type: 'SKIP_WAITING' });
        }
    }
}

function showUpdateBanner() {
    var banner = document.createElement('div');
    banner.id = 'sw-update-banner';
    banner.style.cssText = [
        'position: fixed',
        'bottom: 0',
        'left: 0',
        'right: 0',
        'padding: 12px 48px 12px 20px',
        'background: #333',
        'color: #fff',
        'font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        'font-size: 14px',
        'text-align: center',
        'z-index: 99999',
        'box-shadow: 0 -2px 8px rgba(0,0,0,0.2)'
    ].join(';');

    var text = document.createElement('span');
    text.textContent = 'App has been updated to the latest version';

    var closeBtn = document.createElement('button');
    closeBtn.innerHTML = '&#10005;';
    closeBtn.style.cssText = [
        'position: absolute',
        'right: 16px',
        'top: 50%',
        'transform: translateY(-50%)',
        'background: none',
        'border: none',
        'color: #fff',
        'font-size: 18px',
        'cursor: pointer',
        'opacity: 0.7',
        'padding: 0 4px',
        'line-height: 1'
    ].join(';');
    closeBtn.onclick = function () {
        if (autoHide) clearTimeout(autoHide);
        removeBanner(banner);
    };

    banner.appendChild(text);
    banner.appendChild(closeBtn);
    document.body.appendChild(banner);

    var autoHide = setTimeout(function () {
        removeBanner(banner);
    }, 10000);
}

function removeBanner(banner) {
    banner.style.transition = 'transform 0.3s ease-in';
    banner.style.transform = 'translateY(100%)';
    setTimeout(function () {
        if (banner.parentNode) banner.parentNode.removeChild(banner);
    }, 300);
}

// After reload: check if we just updated, show the banner, then clear the flag.
(function () {
    try {
        if (sessionStorage.getItem('sw-updated') === '1') {
            sessionStorage.removeItem('sw-updated');
            if (document.readyState === 'loading') {
                document.addEventListener('DOMContentLoaded', showUpdateBanner);
            } else {
                showUpdateBanner();
            }
        }
    } catch (e) {}
})();

function checkValidServiceWorker(swUrl, config) {
    // Check if the service worker can be found. If it can't reload the page.
    fetch(swUrl, {
        headers: { 'Service-Worker': 'script' },
    })
        .then((response) => {
            // Ensure service worker exists, and that we really are getting a JS file.
            const contentType = response.headers.get('content-type');
            if (
                response.status === 404 ||
                (contentType != null && contentType.indexOf('javascript') === -1)
            ) {
                // No service worker found. Probably a different app. Reload the page.
                navigator.serviceWorker.ready.then((registration) => {
                    registration.unregister().then(() => {
                        window.location.reload(true);
                    });
                });
            } else {
                // Service worker found. Proceed as normal.
                registerValidSW(swUrl, config);
            }
        })
        .catch(() => {
            console.log('No internet connection found. App is running in offline mode.');
        });
}

export function unregister() {
    if ('serviceWorker' in navigator) {
        navigator.serviceWorker.ready
            .then((registration) => {
                registration.unregister();
            })
            .catch((error) => {
                console.error(error.message);
            });
    }
}

export function updateServiceWorker() {
    
    if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
        navigator.serviceWorker.getRegistration(swUrl).then(registration => {
            console.log("updateServiceWorker", registration);
            if (registration) {
                console.log("updateServiceWorker registration not null");
                registration.update();
            } 
        });
    }
}